<template>
  <v-container fluid class="pa-0 ma-8">
    <!-- <v-btn @click="promptAll" rounded="xl" class="ma-3">مطالبة الكل</v-btn> -->
    <!-- <DialogSimp2
      :v-model="dialogSimp2"
      :confirmFunction="promptAll2"
      :message="promptMsg"
      :btnText="btnText"
    /> -->
    <DialogActionPromptAll :saveFunction="promptAll" />
    <v-autocomplete
      v-model="customer_id"
      label="الزبون"
      :items="filteredCustomers"
      item-title="name"
      item-text=""
      item-value="id"
      placeholder="Search by customer"
      prepend-inner-icon="mdi-magnify"
      menu-icon=""
      rounded
      theme="light"
      variant="solo"
      auto-select-first
      item-props
      attach="body"
      :menu-props="{ maxHeight: '280', offsetY: true }"
    ></v-autocomplete>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="customerActions"
      class="elevation-1"
    >
      <template v-slot:no-data>
        <h3>No data available</h3>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>الحركات المالية</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <DialogActionPayment
            v-if="customer_id != -1"
            :item="item"
            :saveFunction="savePaymnet"
            iconName="mdi-plus"
          />
          <DialogActionFix
            v-if="customer_id != -1"
            :item="item"
            :saveFunction="saveFix"
            iconName="mdi-plus"
          />
          <v-btn
            variant="tonal"
            v-if="customer_id != -1"
            @click="promptCustomer"
            >مطالبة</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <DialogPrint
            v-if="item.actionType == 'payment'"
            :item="item"
            iconName="mdi-printer"
          />
          <DialogSimp
            v-if="item.actionType == 'prompt'"
            :v-model="dialogSimp"
            iconName="mdi-delete"
            :item="item"
            :confirmFunction="deleteItem"
            :message="messages.delete"
          />
        </v-row>
      </template>

      <template v-slot:[`item.value`]="{ item }">
        <v-container>
          <NumberFormat :number="item.value" />
        </v-container>
      </template>
      <template v-slot:[`item.old_balance`]="{ item }">
        <v-container>
          <NumberFormat :number="item.old_balance" />
        </v-container>
      </template>
      <template v-slot:[`item.current_balance`]="{ item }">
        <v-container>
          <NumberFormat :number="item.current_balance" />
        </v-container>
      </template>
      <template v-slot:[`item.totalDiscount`]="{ item }">
        <v-container>
          <NumberFormat :number="item.totalDiscount" />
        </v-container>
      </template>
      <template v-slot:[`item.amount`]="{ item }">
        <v-container>
          <!-- <p>{{ item.last_reading - item.last_paid }}</p> -->
          <NumberFormat :number="item.last_reading - item.last_paid" />
          <!-- <p>
            {{ $n(item.last_reading - item.last_paid, "currency") }}
          </p> -->
        </v-container>
      </template>
      <template v-slot:[`item.actionType`]="{ item }">
        <v-container>
          <p class="text-red" v-if="item.actionType == 'prompt'">
            {{ $t(`${item.actionType}`) }}
          </p>
          <p class="text-green" v-if="item.actionType == 'payment'">
            {{ $t(`${item.actionType}`) }}
          </p>
        </v-container>
      </template>
    </v-data-table>
  </v-container>
  <overlay-loader v-model="loading" />
</template>
<script>
import DialogActionPromptAll from "@/components/dialogs/DialogActionPromptAll.vue";
import DialogActionPayment from "@/components/dialogs/DialogActionPayment.vue";
import DialogActionFix from "@/components/dialogs/DialogActionFix.vue";
import DialogPrint from "@/components/dialogs/DialogPrint.vue";

import repo from "@/store/repo.js";
import swalFun from "@/plugins/swalFun";
import OverlayLoader from "@/components/common/OverlayLoader.vue";
//import DialogSimp2 from "@/components/DialogSimp2.vue";
import DialogSimp from "@/components/DialogSimp.vue";
import NumberFormat from "@/components/NumberFormat.vue";

import { api } from "@/plugins/api";
import timing from "@/plugins/timing";
import store from "@/store/index.js";

export default {
  components: {
    DialogActionPayment,
    DialogActionFix,
    OverlayLoader,
    DialogPrint,
    //DialogSimp2,
    DialogSimp,
    NumberFormat,
    DialogActionPromptAll,
  },
  data: () => ({
    loading: false,
    headers: [
      { title: "النوع", key: "actionType", sortable: false },
      { title: "القيمة", key: "value", sortable: false },
      { title: "الخصم الكلي", key: "totalDiscount", sortable: false },
      { title: "الرصيد السابق", key: "old_balance", sortable: false },
      { title: "الرصيد الحالي", key: "current_balance", sortable: false },
      { title: "آخر قراءة", key: "last_reading", sortable: false },
      { title: "القراءة السابقة", key: "last_paid", sortable: false },
      { title: "الاستهلاك", key: "amount", sortable: false },
      { title: "تاريخ العملية", key: "actionDate", sortable: false },
      {
        title: "العلبة",
        key: "customer.meters[0].parent.name",
        sortable: false,
      },
      { title: "العمليات", key: "actions", sortable: false },
    ],
    dialog: false,
    dialogSimp2: false,
    dialogSimp: false,
    editedIndex: -1,
    messages: {
      delete: "هل أنت متأكد",
    },
    customer_id: null,
    actions: [],
    customers: [],
  }),
  computed: {
    promptMsg() {
      return this.$t("promptMsg");
    },
    btnText() {
      return this.$t("promptAll");
    },
    customerActions() {
      return this.actions;
    },

    filteredCustomers() {
      //console.log("customers: ", this.customers);
      return this.customers;
    },
  },
  methods: {
    async deleteItem(item) {
      const res = await repo.actions.delete(item.id);
      if (res) {
        swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
    },
    async promptAll2() {
      const res = await repo.actions.promptAllCustomers();
      if (res) {
        swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
    },
    async promptAll(sector_id) {
      this.loading = true;
      const res = await repo.actions.promptAllCustomersBySector(sector_id);
      if (res) {
        swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
      this.loading = false;
    },
    async fetchActions() {
      this.loading = true;
      var st = timing.getCurr();
      try {
        await store.dispatch("fetchCustomerActions", this.customer_id);
        this.actions = store.getters.getAllActions;
      } catch (error) {
        //
      }
      var en = timing.getCurr();
      var diff = timing.calcDiff(st, en);
      console.log("time: get customers list:", diff);

      this.loading = false;
    },
    async fetchCustomers() {
      this.loading = true;
      var st = timing.getCurr();
      try {
        const response = await api.get(`/customerslist`);
        this.customers = response.data.data;
      } catch (error) {
        //
      }
      var en = timing.getCurr();
      var diff = timing.calcDiff(st, en);
      console.log("time: get customers list:", diff);
      this.loading = false;
    },
    async promptCustomer() {
      //console.log("ccc", this.customer_id);
      const res = await repo.actions.promptCustomer(this.customer_id);
      if (res) {
        swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
    },
    async savePaymnet(formData) {
      //console.log("form before", formData);
      formData.customer_id = this.customer_id;
      //console.log("form after", formData);
      const res = await repo.actions.addPayment(formData);
      if (res) {
        swalFun.success("success");
        //this.fetchActions();
      } else {
        swalFun.fail("error");
      }
    },
    async saveFix(formData) {
      formData.customer_id = this.customer_id;
      const res = await repo.actions.addFix(formData);
      if (res) {
        swalFun.success("success");
        this.fetchActions();
      } else {
        swalFun.fail("error");
      }
    },
  },
  watch: {
    customer_id: {
      immediate: true,
      // handler(newValue, oldValue) {
      //   this.onCustomerIdChange(newValue, oldValue);
      // },
      handler() {
        this.fetchActions();
      },
    },
  },
  async mounted() {
    await this.fetchCustomers();
  },
};
</script>
